import React from 'react';
import { IContentHeader } from './interfaces';
import { alpha, Box, Typography } from '@mui/material';
import { BORDER_COLOR } from '../../../../../../constants';
import { Image } from '@components/Image';
import { ManagePortalButton } from '@components/ManagePortalButton';
import { RankingPodiumOverlay } from '../../../Results/Overview/components/RankingPodiumOverlay';

export const ContentHeader: React.FC<IContentHeader> = ({
  title,
  backgroundSrc,
  manageHref,
  podium,
  enrollmentCount,
  children,
}): JSX.Element => {
  const hasPodiumOverlay = podium !== undefined;

  return (
    <Box component="header">
      <Box
        sx={{
          position: 'relative',
          height: '400px',
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
          overflow: 'hidden',
        }}
      >
        <Image
          imageSrc={backgroundSrc}
          height="400px"
          sx={{
            mt: 0,
            border: 'none',
            borderRadius: 0,
          }}
        />
        {hasPodiumOverlay && (
          <RankingPodiumOverlay
            podium={podium ?? []}
            enrollmentCount={enrollmentCount}
            size="large"
          />
        )}
        {manageHref && <ManagePortalButton href={manageHref} />}
        {!hasPodiumOverlay && (
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              p: '10px',
              bottom: '10px',
              background: alpha('#FFF', 0.5),
              backdropFilter: 'blur(6px)',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: 'text.primary',
              }}
            >
              {title}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          bgcolor: '#FFF',
          p: '5px',
          pb: '0',
          border: `.5px solid ${BORDER_COLOR}`,
        }}
      >
        {hasPodiumOverlay && (
          <Typography
            variant="h1"
            sx={{
              px: 1,
              pt: 1,
              pb: 0.5,
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
